import { deriveLinearConversionFactors } from "../../Units/UnitConversion.js";
import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SensorElementConfig } from "./types.js";

type LinearConfig = SensorElementConfig<Record<string, never>, typeof SensorConversions.linearWithMinAndMax>;

const { slope, offset } = deriveLinearConversionFactors("inches_of_mercury", "kilopascal");

export const imperialBarometricPressureElementConfig: LinearConfig = {
    legalConvertedRange: [0, null],
    conversionKey: "linearWithMinAndMax",
    parameterConfigs: {},
    buildConversionParams: () => ({
        slope,
        offset,
        outputMin: 0,
        outputMax: Number.MAX_VALUE,
    }),
    decodedUnits: "inches_of_mercury",
    convertedUnits: "kilopascal",
    unitCategory: "barometricPressure",
    testCases: [
        { parameters: {}, decodedValue: 0, convertedValue: 0 },
        // Standard atmosphere: 29.9212 inHg ~= 101.325 kPa
        { parameters: {}, decodedValue: 29.9212, convertedValue: 101.32482 },
    ],
} as const;
